import React from 'react';
import { Sparkles } from 'lucide-react';

const LimitedTimeNotice = () => {
  return (
    <section className="section-padding-small" style={{ 
      background: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Decorative glow */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '600px',
        height: '300px',
        background: 'radial-gradient(ellipse, rgba(212, 175, 55, 0.15) 0%, transparent 70%)',
        pointerEvents: 'none'
      }} />
      
      <div className="luxury-container" style={{ position: 'relative', zIndex: 1 }}>
        <div style={{ 
          maxWidth: '900px', 
          margin: '0 auto', 
          textAlign: 'center',
          padding: '60px 40px',
          border: '2px solid var(--accent-gold)',
          borderRadius: '0px',
          position: 'relative',
          background: 'rgba(26, 26, 26, 0.5)',
          backdropFilter: 'blur(10px)'
        }}>
          <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'center', gap: '12px' }}>
            <Sparkles size={24} color="var(--accent-gold)" fill="var(--accent-gold)" />
            <Sparkles size={32} color="var(--accent-gold)" fill="var(--accent-gold)" />
            <Sparkles size={24} color="var(--accent-gold)" fill="var(--accent-gold)" />
          </div>
          <h3 className="heading-2" style={{ marginBottom: '16px', color: 'var(--bg-primary)' }}>
            Limited Availability: Deferred Service Fee
          </h3>
          <p className="body-large" style={{ color: 'var(--accent-gold-light)', marginBottom: '12px', fontWeight: '500' }}>
            Exclusive opportunity for select clients to access our premium tax preparation services
          </p>
          <p className="body-small" style={{ color: 'rgba(255, 255, 255, 0.6)', fontStyle: 'italic' }}>
            Subject to eligibility. Terms apply.
          </p>
        </div>
      </div>
    </section>
  );
};

export default LimitedTimeNotice;